import React from 'react';
import '../styles/NewsListSkeleton.css';

const NewsListSkeleton = ({
  count = 8,
  variant = 'subsection',
}) => {
  const isSearch = variant === 'search';
  const cardCount = isSearch ? count : Math.max(0, count - 1);

  return (
    <div
      className={`news-list-skeleton news-list-skeleton--${variant}`}
      aria-hidden="true"
    >
      {!isSearch && (
        <div className="news-list-skeleton__hero">
          <div className="news-list-skeleton__hero-content">
            <div className="news-list-skeleton__meta" />
            <div className="news-list-skeleton__hero-title" />
            <div className="news-list-skeleton__hero-title news-list-skeleton__hero-title--short" />
          </div>
        </div>
      )}

      <div className="news-list-skeleton__cards">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div className="news-list-skeleton__card" key={index}>
            <div className="news-list-skeleton__image" />

            <div className="news-list-skeleton__content">
              <div className="news-list-skeleton__meta" />
              <div className="news-list-skeleton__title-line" />
              <div className="news-list-skeleton__title-line news-list-skeleton__title-line--medium" />
              <div className="news-list-skeleton__title-line news-list-skeleton__title-line--short" />
              {variant === 'search' && (
                <div className="news-list-skeleton__section" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsListSkeleton;
